import { render, staticRenderFns } from "./ConferenceList.vue?vue&type=template&id=26c33873&scoped=true&"
import script from "./ConferenceList.vue?vue&type=script&lang=js&"
export * from "./ConferenceList.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceList.vue?vue&type=style&index=0&id=26c33873&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c33873",
  null
  
)

export default component.exports